import React from 'react';

import { StyledListingCategoryTitle } from './ListingCategoryTitle.styles';

import { ListingCategoryTitleProps } from './ListingCategoryTitle.types';

const ListingCategoryTitle = ({
  category,
  filters = [],
  componentClassname = 'listing-category-title',
  customClassnames = '',
  customStyle = '',
  ...props
}: ListingCategoryTitleProps) => {
  return (
    <StyledListingCategoryTitle
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
      {...props}
    >
      <span
        className={`${componentClassname}__name ${
          !filters?.length && `${componentClassname}__name--no-filter`
        }`}
      >
        {category}
      </span>

      {!!filters?.length &&
        filters.map((filter, index) => (
          <span
            key={`filter_${index}_${new Date().getTime()}`}
            className={`${componentClassname}__filter`}
          >
            {filter}
          </span>
        ))}
    </StyledListingCategoryTitle>
  );
};
ListingCategoryTitle.displayName = 'ListingCategoryTitle';

export default ListingCategoryTitle;
